import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Delete unavailability among the week
 * @param interval blockedInterval
 */
export default async function deleteBlockedInterval(interval: BlockedInterval) {
  // sanity check
  if (
    interval.timeslot_id === "" ||
    interval.timeslot_id === undefined ||
    interval.timeslot_id === null
  ) {
    return;
  }
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/unavailability/${interval.timeslot_id}`,
    { method: "DELETE" },
  );
  if (!res.ok) {
    throw new Error(
      `failed to delete blocked time interval: ${getErrorDetail(
        await res.text(),
      )}`,
    );
  }
  return res;
}
